import format from 'date-fns/format'
import formatDistance from 'date-fns/formatDistance'

export default date =>
  `${format(date, 'ddd DD/MM/YYYY')} (${formatDistance(
    date,
    Date.now() - 9 * 60 * 60 * 1000,
    {
      addSuffix: true
    }
  )})`

// // For date-fns@2.0.0-alpha.8+
// export default date =>
//   `${format(course.date, 'E dd/MM/yyyy')} (${formatDistance(
//     course.date,
//     Date.now() - 9 * 60 * 60 * 1000,
//     {
//       addSuffix: true
//     }
//   )})`



// WEBPACK FOOTER //
// ./src/views/CourseList/CoursePanel/helpers/format-date.js